module.exports = __webpack_public_path__ + "static/media/device-fullpage.c31790ee.jpg";